import { render, staticRenderFns } from "./ServicepointEditableDetail.vue?vue&type=template&id=1b1d4db8&scoped=true"
import script from "./ServicepointEditableDetail.vue?vue&type=script&lang=ts"
export * from "./ServicepointEditableDetail.vue?vue&type=script&lang=ts"
import style0 from "./ServicepointEditableDetail.vue?vue&type=style&index=0&id=1b1d4db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1d4db8",
  null
  
)

export default component.exports